"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongooseState = void 0;
var MongooseState;
(function (MongooseState) {
    MongooseState[MongooseState["Disconnected"] = 0] = "Disconnected";
    MongooseState[MongooseState["Connected"] = 1] = "Connected";
    MongooseState[MongooseState["Connecting"] = 2] = "Connecting";
    MongooseState[MongooseState["Disconnecting"] = 3] = "Disconnecting";
    MongooseState[MongooseState["Uninitialized"] = 99] = "Uninitialized";
})(MongooseState = exports.MongooseState || (exports.MongooseState = {}));
//# sourceMappingURL=mongoose.js.map